import { useState } from 'react';
import api from '../../api';

export default function CustomerForm({ onCreated, onClose }) {
  const [form, setForm] = useState({ phone:'', full_name:'', birth_date:'' });
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault(); setError('');
    try {
      const res = await api.post('/customers/', {
        phone: form.phone,
        full_name: form.full_name || null,
        birth_date: form.birth_date ? new Date(form.birth_date).toISOString() : null,
      });
      onCreated(res.data);
      onClose();
    } catch(err) { setError(err.response?.data?.detail || 'Помилка'); }
  }

  return (
    <div style={styles.wrap}>
      <h4 style={styles.title}>Новий клієнт</h4>
      <form onSubmit={handleSubmit}>
        <input style={styles.input} placeholder="+380501234567"
          value={form.phone} onChange={e => setForm({...form, phone:e.target.value})} required />
        <input style={styles.input} placeholder="Ім'я (необов'язково)"
          value={form.full_name} onChange={e => setForm({...form, full_name:e.target.value})} />
        <label style={styles.dateLabel}>Дата народження</label>
        <input style={styles.input} type="date"
          value={form.birth_date} onChange={e => setForm({...form, birth_date:e.target.value})} />
        {error && <p style={styles.error}>{error}</p>}
        <div style={styles.btns}>
          <button type="submit" style={styles.saveBtn}>Зберегти</button>
          <button type="button" style={styles.cancelBtn} onClick={onClose}>Скасувати</button>
        </div>
      </form>
    </div>
  );
}

const styles = {
  wrap: { margin:'0 12px 12px', background:'#1c1812', borderRadius:'10px', padding:'14px', border:'1px solid #f5a623' },
  title: { color:'#f5a623', margin:'0 0 10px', fontSize:'13px' },
  input: { width:'100%', padding:'8px 12px', borderRadius:'7px', border:'1px solid #38301f', background:'#211c14', color:'#fff', fontSize:'13px', boxSizing:'border-box', marginBottom:'8px' },
  dateLabel: { display:'block', color:'#9a8a6e', fontSize:'11px', marginBottom:'4px' },
  btns: { display:'flex', gap:'8px', marginTop:'4px' },
  saveBtn: { flex:1, padding:'8px', background:'#f5a623', color:'#14110c', border:'none', borderRadius:'7px', fontWeight:'bold', cursor:'pointer', fontSize:'13px' },
  cancelBtn: { flex:1, padding:'8px', background:'transparent', color:'#9a8a6e', border:'1px solid #38301f', borderRadius:'7px', cursor:'pointer', fontSize:'13px' },
  error: { color:'#ff6b6b', fontSize:'12px', marginBottom:'8px' },
};
